import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EParametersFormValues = {
	vendor: 'vendor',
	technology: 'technology',
	nodeType: 'nodeType',
	configurationDate: 'configurationDate',
	nodes: 'nodes',
	version: 'version',
	configType: 'configType',
} as const;

export type TParametersFormValues = TValueOfStringRecord<typeof EParametersFormValues>
